const URL_API = "https://back-ecommerce.sise.edu.pe";
//const URL_API = "https://dev-ecommerse.sise.edu.pe";
const courseModality = JSON.parse(localStorage.getItem('course_modality') || '[]');

function deriveKey(token, salt) {
  return CryptoJS.PBKDF2(token, salt, {
    keySize: 256 / 32,
    iterations: 100000,
    hasher: CryptoJS.algo.SHA256
  });
}

function encryptWithToken(data, token) {
  const salt = CryptoJS.lib.WordArray.random(16);
  const iv = CryptoJS.lib.WordArray.random(16);
  const key = deriveKey(token, salt);

  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7
  }).ciphertext;

  const payload = salt.clone().concat(iv).concat(ciphertext);
  const hmac = CryptoJS.HmacSHA256(payload, key).toString();

  return {
    payload: CryptoJS.enc.Base64.stringify(payload),
    hmac
  };
}

function decryptWithToken(encrypted, token) {
  const full = CryptoJS.enc.Base64.parse(encrypted.payload);

  const salt = CryptoJS.lib.WordArray.create(full.words.slice(0, 4));
  const iv = CryptoJS.lib.WordArray.create(full.words.slice(4, 8));
  const ciphertext = CryptoJS.lib.WordArray.create(full.words.slice(8));
  const key = deriveKey(token, salt);

  const recalculated = CryptoJS.HmacSHA256(full, key).toString();
  if (recalculated !== encrypted.hmac) {
    console.error("HMAC mismatch", {
      expected: encrypted.hmac,
      actual: recalculated
    });
    throw new Error("HMAC inválido");
  }

  const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
    iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7
  });

  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}

async function abrirPopupIzipay(encryptedConfig, token) {
  const config = decryptWithToken(encryptedConfig, token);

  const checkout = new window.Izipay({ config });

  await checkout.LoadForm({
    authorization: config.token,
    keyRSA: "RSA",
    callbackResponse: async (response) => {
      document.getElementById("loading-container").style.display = "flex";
      const encryptedOrder = encryptWithToken(response, token);
      const res = await fetch(`${URL_API}/api/shopify/order/create`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ encryptedData: encryptedOrder, token, courseModality})
      });
      if (res.ok) {
        const response = await res.json();
        if (response.order_status_url && response.code === '00') {
           
          await fetch('/cart/clear.js', { method: 'POST' });
          document.getElementById("loading-container").style.display = "none"; 
          Swal.fire({
            title: "Excelente!",
            text: "Pago realizado exitosamente",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#000",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            //timer:3500,
            showClass: {
                popup: `
                  animate__animated
                  animate__fadeInUp
                  animate__faster
                `
              },
            hideClass: {
              popup: `
                animate__animated
                animate__fadeOutDown
                animate__faster
              `
            }
          }).then((result) => {
            if (result.isConfirmed) {
              // Antes de redireccionar limpiamos el localstorage
              localStorage.setItem('course_modality', JSON.stringify([]));
              console.log('Redireccionando...');
              window.location.href = 'https://formate.sise.edu.pe/pages/gracias-por-tu-compra?id=' + response.id;
            }
          });
          //window.location.href = result.order_status_url;
        } else {
          window.location.href = '/';
        }
      } else {
        const err = await res.json();
        document.getElementById("loading-container").style.display = "none";
        Swal.fire({
          title: "Ups...",
          text: `${err.message ?? 'Ocurrió un error, intentelo más tarde por favor'}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#231F20",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
          timer:3500,
          showClass: {
              popup: `
                animate__animated
                animate__fadeInUp
                animate__faster
              `
            },
          hideClass: {
            popup: `
              animate__animated
              animate__fadeOutDown
              animate__faster
            `
          }
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = '/cart';
          }
        });
      }
    }
  });
}

document.querySelector("#submit_data")?.addEventListener("click", async (e) => {
  e.preventDefault();
  const firstName = document.getElementById("first_name").value;
  const lastName = document.getElementById("last_name").value;
  const email = document.getElementById("email").value;
  const address = document.getElementById("address").value;
  const phone = document.getElementById("phone").value.replace(/\s+/g, '');  
  const documentValue = document.getElementById("document").value.replace(/\s+/g, '');

  if (!firstName || !lastName || !email || !address || !phone || !documentValue) {
    showError("Por favor, complete todos los campos antes de continuar.");
    return; 
  }

  if (!/^\d{8}$/.test(documentValue)){
    showError("El DNI debe tener exactamente 8 dígitos numéricos.");
    document.getElementById("document").focus();
    return; 
  }
  
  if (!/^\d{9}$/.test(phone)) {
    showError("El número de celular debe tener exactamente 9 dígitos numéricos.");
    document.getElementById("phone").focus();
    return; 
  }

  function showError(message) {
    Swal.fire({
      title: "Ups...",
      text: message,
      icon: "error",
      showCancelButton: false,
      confirmButtonColor: "#231F20",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
      showClass: {
        popup: `
          animate__animated
          animate__fadeInUp
          animate__faster
        `
      },
      hideClass: {
        popup: `
          animate__animated
          animate__fadeOutDown
          animate__faster
        `
      }
    });
  }

  document.getElementById("loading-container").style.display = "flex"; 
  document.getElementById("submit_data").disabled = true; 

  const data = {
    first_name: firstName,
    last_name: lastName,
    email: email,
    address: address,
    phone: phone,
    document: documentValue,
  };
  
  const cartData = await fetch("/cart.js").then(res => res.json());
  const itemsCod = cartData.items.map(item => item.sku);
  data.items_cod = itemsCod;
  
  try {
    const tokenRes = await fetch(`${URL_API}/api/shopify/token/generate`, { method: "POST" });
    const { token } = await tokenRes.json();
    const cartData = await fetch("/cart.js").then(res => res.json());

    const encryptedCustomer = encryptWithToken(data, token);
    const encryptedCart = encryptWithToken(cartData, token);
    const encryptedGroups = encryptWithToken(courseModality, token);

    const initRes = await fetch(`${URL_API}/api/shopify/init-payment`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ customer: encryptedCustomer, cart: encryptedCart, groups: encryptedGroups, token })
    });

    // Se continúa con el flujo del proceso
    const initData = await initRes.json();

    if (initData.encryptedConfig) {
      await abrirPopupIzipay(initData.encryptedConfig, token);
    } else {
      document.getElementById("loading-container").style.display = "none";
      Swal.fire({
        title: "Ups...",
        text: initData['message'] ?? 'No recibimos configuración Izipay',
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#231F20",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
        //timer:3500,
        showClass: {
            popup: `
              animate__animated
              animate__fadeInUp
              animate__faster
            `
          },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `
        }
      });
      return; 
      console.warn("No recibimos configuración Izipay");
    }

  } catch (error) {
    document.getElementById("loading-container").style.display = "none";
    console.error("Error en el proceso de pago", error);
  } finally {
    document.getElementById("loading-container").style.display = "none"; 
    document.getElementById("submit_data").disabled = false; 
  }

  //document.getElementById("customModal").style.display = "none";
});
